import z from "zod";
import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

import { zodParseWithLog } from "src/api/apiErrorLogs";
import { Scores, ScoresSchema } from "../post/scoreSchema";
import { ScoreQuery } from "src/context/EntityBasedScore/useEntityBasedScoreParams";

export const getOnePackagingKey = "getOnePackaging" as const;

type Options = {
    packagingId: (string | number) | undefined;
    scoreQuery?: ScoreQuery;
};
export const useGetOnePackaging = (options: Options) => {
    const { packagingId, scoreQuery = {} } = options;

    const scoreQueryValues = Object.values(scoreQuery);
    const query = useQuery({
        queryKey: [getOnePackagingKey, packagingId, ...scoreQueryValues],
        cacheTime: 0,
        enabled: packagingId !== undefined,
        queryFn: async () => {
            const url = `/api/packagings/${packagingId}`;

            const response = await loggedInApiCall.get<Packaging>(url, {
                params: scoreQuery,
            });
            return response;
        },
        select: (request) => {
            const data = zodParseWithLog(request.data, PackagingZodSchema, getOnePackagingKey);
            return data;
        },
    });

    return {
        packaging: query.data,
        ...query,
    };
};

export type Packaging = {
    "@id": IRI;
    id: number;
    name: string;
    externalId?: string;
    ssqId?: number;
    scores: Scores;
    canView: boolean;
    canModify: boolean;
    canDelete: boolean;
};

export const PackagingZodSchema: z.ZodSchema<Packaging> = z.object({
    "@id": z.string(),
    id: z.number(),
    name: z.string(),
    externalId: z.string().optional(),
    ssqId: z.number().optional(),
    scores: ScoresSchema,
    canView: z.boolean(),
    canModify: z.boolean(),
    canDelete: z.boolean(),
});
